import { Box, Typography } from '@mui/material';
import { cx } from '../../helpers/global';
import { formatDollarAmount } from '../../utils/global/helper';

export default function PaymentLineItem({
  subtract,
  label,
  value,
  isTotal,
}: {
  subtract?: boolean;
  label: string;
  value: number | string;
  isTotal?: boolean;
}) {
  return (
    <Box
      className={cx('payment-section-row', isTotal && 'total')}
      sx={
        isTotal
          ? {
              paddingTop: '10px',
              borderTop: theme => `1px solid ${theme.palette.darkGrey.main}`,
            }
          : undefined
      }>
      <Typography variant={isTotal ? 'h3' : 'body1'} component="p">
        {label}
      </Typography>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          variant={isTotal ? 'h1' : 'body1'}
          color={subtract ? (isTotal ? 'secondary' : 'primary') : undefined}
          component="p">
          {typeof subtract === 'boolean' && subtract && !isTotal ? '-' : ''}
          {typeof value === 'number'
            ? formatDollarAmount(value, value === 0)
            : value}
        </Typography>
      </div>
    </Box>
  );
}
